<template lang="pug">
  div
    navbar
    router-view#app
    footer-component.mb-4
</template>

<script>
import Navbar from '@/components/Navbar.vue'
import Footer from '@/components/Footer.vue'

export default {
  name: "Dashboard",
  components: {
    Navbar,
    'footer-component': Footer
  }
}
</script>

<style lang="stylus">
html,body 
  margin 0px
  font-family "Open Sans", "Helvetica Neue", Helvetica, Arial, sans-serif
h1
  font-weight 500
#app
  margin-top 80px
</style>
